import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail.sectionId;
    const elements = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
    elements.forEach((element) => {
      init(element);
    });
  });
};
